<template>
  <div class="amal">
    <div class="amal__content">
        <div class="amal__items">
            <div class="amal__items-row">
                <div class="amal__items-row-col1">
                    <img src="@/assets/images/png/Torttulik.png" alt="">
                </div>
                <div class="amal__items-row-col2">
                    <span class="f-22">
                        Төрт түлік мал
                    </span>
                    <p class="f-14" v-html="title">

                    </p>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {   
    data: () => ({
        title: `Төрт түлік – мал: түйе, жылқы, қой, сиыр. Қазақ халқы осы төртеуін төрт түлік деп атаған. Ауыз әдебиетінде “төрт түлік малды құрадың” деген тіркес жиі кездеседі. Бұл дәулетіне сәулеті сай адамдарға арналып айтылған. Мысалы, “Байбөрі деген бар екен, Байбөрі малға бай екен, Төрт түлігі сай екен...” (“Алпамыс батыр” жырынан). Халық төрт түліктің әрқайсысының сақтаушы иесі бар деп ұғынып, оларды ойсылқара, қамбар ата, шопан ата, зеңгі баба деп атаған. Төрт түлікті кейде жұп (аша, айыр) тұяқ, тақ (тік) тұяқ деп те атайды. Қазақ төрт түліктің ішінде түйе малын байлық ретінде де, көлік ретінде де, азық ретінде де қатты қастерлеген. “Нар жолында жүк қалмас” деген мәтел осының айғағы. “Ат – ердің қанаты”, “Мінсең – көлік, жесең – ет” деп жылқы малын да аса жоғары бағалаған. Сондай-ақ қой мен ешкі, сиыр малының да өзіне тән ерекше қасиеттері болатынын ұмытпаған. Көшпелілердің, оның ішінде қазақтың төрт түлік малдың ішіндегі қастерлеп, пір тұтатыны – жылқы. Жылқы көшіп-қонуға төзімді әрі ыңғайлы, қысы-жазы жем-шөп тілемей жайылады. Оның азығы (жемі, шөбі) өзге малдан әлдеқайда асыл. Сол себепті де оның еті де,сүті де денсаулыққа шипалы екендігі ерте кезден – ақ белгілі. Жылқы бетегелі, көделі, селеулі, қауданды жерде жақсы өскен. Қазақ даласының батысында Мұғалжар тауынан басталып, Сарыарқаны қуалай отырып, аяғы Батыс Сібірге тірелетін кең өлкесінде жылқы малы көп өсірілген. Қазақтың жылқымен қатар ұстаған малы – түйе. Қазақта «Түйелі бай қонады сортаңды алып» деп басталатын өлең бар. Бұлай деудің себебі, ертедегі түйелер байлар суы тұзды көлдердің, теңіздердің, өзендердің бойларына, өсімдігі ащы, сортаң жерлерге қонатын болған.`
    })

}
</script>

<style>

</style>